import { render, staticRenderFns } from "./UserCentreLcManagement.vue?vue&type=template&id=4d33b784&"
import script from "./UserCentreLcManagement.vue?vue&type=script&lang=js&"
export * from "./UserCentreLcManagement.vue?vue&type=script&lang=js&"
import style0 from "./UserCentreLcManagement.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports